import { render, staticRenderFns } from "./BulkUploadChartOfAccount.vue?vue&type=template&id=18898d84"
import script from "./BulkUploadChartOfAccount.vue?vue&type=script&lang=js"
export * from "./BulkUploadChartOfAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports